import { AxiosResponse } from 'axios';
import { AuthenticatedClient, SearchParamsType, SearchResponseType } from '_api';

export const searchPlanningData = (params: SearchParamsType): Promise<AxiosResponse<SearchResponseType>> => {
  return AuthenticatedClient.post('/search-planning/', params);
};
